module.exports = __webpack_public_path__ + "img/logo_800x542.b408130c.png";